import {
  validateInclusion,
  validateNumber,
  validatePresence,
} from 'ember-changeset-validations/validators';
import {
  AssignmentRuleKind,
  AssignmentRuleMode,
} from 'uplisting-frontend/models/assignment-rule';

export const AssignmentRuleValidation = {
  propertyId: [validatePresence(true)],
  kind: [
    validatePresence(true),
    validateInclusion({ list: Object.values(AssignmentRuleKind) }),
  ],
  mode: [validateInclusion({ list: Object.values(AssignmentRuleMode) })],
  requiredAcceptances: [validateNumber({ integer: true, gte: 1 })],
};
